import React from "react"
import Img from "gatsby-image"
import { useStaticQuery, graphql } from "gatsby"
import { FormattedMessage } from "react-intl"
import { langId } from "../languages"

const CoverImage = ({ imgAlt, imgTitle }) => {
  const Images = useStaticQuery(graphql`
    query {
      coverImg: file(
        relativePath: {
          eq: "images/Home/link-reit-channel-823-q3-2020-rising-stars-at-link-desktop.png"
        }
      ) {
        ...fragmentsFluidImage
      }

      coverImgMobile: file(
        relativePath: {
          eq: "images/Home/link-reit-channel-823-q3-2020-rising-stars-at-link-mobile.png"
        }
      ) {
        ...fragmentsFluidImage
      }

      logo: file(
        relativePath: {
          eq: "images/Home/link-reit-channel-823-q3-2020-linkreit-channel-823-logo-2.png"
        }
      ) {
        ...fragmentsFluidImage
      }
    }
  `)
  return (
    <div className="cover-image">
      <Img
        fluid={Images.coverImg.childImageSharp.fluid}
        className="cover-image__img"
        alt={imgAlt}
        title={imgTitle}
      ></Img>
      <Img
        fluid={Images.coverImgMobile.childImageSharp.fluid}
        className="cover-image__img-mobile"
        alt={imgAlt}
        title={imgTitle}
      ></Img>
      <div className="cover-image__logo">
        <Img
          fluid={Images.logo.childImageSharp.fluid}
          className="cover-image__logo__logo"
          alt={imgAlt}
          title={imgTitle}
        ></Img>
        <h1 className="cover-image__logo__text">
          <FormattedMessage id={langId.COVER_IMG_TITLE}></FormattedMessage>
        </h1>
        <div className="cover-image__logo__btn">
          <FormattedMessage id={langId.READ_MORE}></FormattedMessage>
        </div>
      </div>
    </div>
  )
}

export default CoverImage
